import { formatURIComponent } from "./utils"

export default (instance:string) => {
    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=happyIndustry&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '幸福产业',
        pageTitleIcon: '',
        background_img: '',
        description: `华美专注打造以健康、休闲及情感价值为核心的体验型业态。目前行业普遍存在业态同质化严重、用户粘性不足、跨界整合能力薄弱等痛点。华美通过大数据画像精准捕捉高净值客群的情感诉求，再以空间场景化和服务IP化为抓手，设计融合在地文化特色的沉浸式体验，打通"住宿+健康+消费"的跨界生态链。`,
        icons: [
            {
                name: '幸福产业',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/21.幸福产业.pdf'),
                path: "四库赋能-酒店+/幸福产业/幸福产业"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/幸福产业/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/幸福产业/数据赋能'),
                path: "四库赋能-酒店+/幸福产业/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/幸福产业/全球案例/全球案例（幸福产业）.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/幸福产业/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/幸福产业/预警问题/预警问题（幸福产业）.xlsx'),
                path: "四库赋能-酒店+/幸福产业/预警问题"
            }
        ]
    }]
}